import { theme } from '@chakra-ui/react';

import { customColors } from '../tokens';

// This is the v2 adapter. Chakra's default colors remain available here until
// the provider is switched to the v3 system.
export const colors = {
  ...theme.colors,
  ...customColors,
};
